import { Flex, Grid, GridItem, SimpleGrid } from "@chakra-ui/react";
import LoanProgress from "components/analytics/LoanProgress";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import BankAccountBalance from "../BankAccountBalance";
import UnreadMessages from "../UnreadMessages";
import Widget from "../Widget";
import WidgetBox from "../WidgetBox/widget-box";
import { AskLoans } from "./AskLoans";

const LenderDashboard = () => {
  const { user } = useTenant();
  const widgets = user.company.widgets.filter((widget: any) => widget.page === "dashboard");

  return (
    <Flex direction="column" gap={4}>
      <AskLoans />

      <Grid templateColumns={{ base: "1fr", md: "9fr 3fr" }} gap={4}>
        <GridItem>
          <Flex direction="column" gap={4}>
            <SimpleGrid columns={{ base: 1, md: 2 }} gap={4}>
              {widgets.map((widget: any) => (
                <Widget key={widget.id} widget={widget} />
              ))}
            </SimpleGrid>
            <WidgetBox title="Loan Progress">
              <LoanProgress />
            </WidgetBox>
          </Flex>
        </GridItem>
        <GridItem>
          <Flex direction="column" gap={4}>
            <BankAccountBalance />
            <UnreadMessages />
          </Flex>
        </GridItem>
      </Grid>
    </Flex>
  );
};

export default LenderDashboard;
